(function () {
  'use strict';

  const DATA = window.RESCUE_PAGE_DATA || {};
  const VARIANT_ID = DATA.variantId;
  const BASE_PRICE = DATA.boxPrice || 12000; // cents
  const BASE_COMPARE = DATA.boxCompare || 24000; // cents

  function fmt(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function setQty(qty) {
    document.querySelectorAll('[data-rescue-cta]').forEach(function (btn) {
      btn.setAttribute('href', '/cart/' + VARIANT_ID + ':' + qty);
    });

    document.querySelectorAll('.rescue-qty-btn').forEach(function (btn) {
      btn.classList.toggle('rescue-qty-btn--active', btn.getAttribute('data-qty') === String(qty));
    });

    var hint = document.getElementById('rescue-cta-hero');
    if (hint && qty > 1) {
      hint.textContent = 'Order now — ' + qty + ' boxes · ' + fmt(BASE_PRICE * qty);
    } else if (hint) {
      hint.textContent = 'Order now';
    }
  }

  function init() {
    document.querySelectorAll('.rescue-qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setQty(parseInt(btn.getAttribute('data-qty'), 10) || 1);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
